/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { CheckmarkFilled, CheckmarkOutline } from '@carbon/react/icons';
import { Button } from 'carbon-components-react';
import React from 'react';

import { Noop } from '../../../../ts';

interface UpgradeInstanceModalPlanProps {
  strings: any;
  type: 'current' | 'upgrade' | 'enterprise';
  title: string;
  description: string;
  tag?: string;
  features: string[];
  buttonText: string;
  toolTipText?: string;
  onButtonClick?: Noop;
  disabled?: boolean;
}

const UpgradeInstanceModalPlan: React.FC<UpgradeInstanceModalPlanProps> = ({
  strings,
  type,
  title,
  description,
  tag,
  features,
  buttonText,
  toolTipText,
  onButtonClick,
  disabled
}) => (
  <div className="UpgradeInstanceModalPlan">
    {tag && <h4>{tag}</h4>}
    <h3>{strings[title]}</h3>
    <div className="UpgradeInstanceModalPlan__body">
      <p className="UpgradeInstanceModalPlan__text">{strings[description]}</p>
      <ul className="UpgradeInstanceModalPlan__list">
        {features.map(feature => (
          <li key={feature}>
            {type === 'upgrade' ? (
              <CheckmarkFilled size={16} className={type} />
            ) : (
              <CheckmarkOutline size={16} />
            )}
            {strings[feature]}
          </li>
        ))}
      </ul>
      <div className="UpgradeInstanceModalPlan__footer">
        {type === 'current' ? (
          <span>{strings[buttonText]}</span>
        ) : disabled ? (
          <Button
            kind={type !== 'enterprise' ? 'primary' : 'secondary'}
            onClick={onButtonClick}
            title={strings[toolTipText]}
            disabled={disabled}>
            {strings[buttonText]}
          </Button>
        ) : (
          <Button
            kind={type !== 'enterprise' ? 'primary' : 'secondary'}
            onClick={onButtonClick}
            disabled={disabled}>
            {strings[buttonText]}
          </Button>
        )}
      </div>
    </div>
  </div>
);

UpgradeInstanceModalPlan.defaultProps = {
  tag: '',
  buttonText: '',
  features: [],
  onButtonClick: () => {},
  disabled: false
};

export default UpgradeInstanceModalPlan;
